import { render, staticRenderFns } from "./SfTabs.vue?vue&type=template&id=576b95a8&"
import script from "./SfTabs.vue?vue&type=script&lang=ts&"
export * from "./SfTabs.vue?vue&type=script&lang=ts&"
import style0 from "./SfTabs.vue?vue&type=style&index=0&id=576b95a8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports